import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TranslateIcon from '@mui/icons-material/Translate';
import { TranslatePlain } from '../../../shared/LanguageService';
import TooltipText from '../../../shared/feedback/TooltipText';
import { useEditTranslationsToggle } from '../state/useEditTranslationsToggle';
import { editTranslationsShortcutLabel } from '../state/useEditTranslationsShortcut';

function EditTranslationsIconButton() {
    const { editTranslationsEnabled, toggle } = useEditTranslationsToggle(() => undefined);
    const label = TranslatePlain('header/nav/edit-translations');

    return (
        <Tooltip
            title={
                <TooltipText variant="body1">
                    {TranslatePlain('translation-editor/shortcut', {
                        shortcut: editTranslationsShortcutLabel
                    })}
                </TooltipText>
            }
            placement="bottom"
        >
            <IconButton
                aria-label={label}
                aria-pressed={editTranslationsEnabled}
                onClick={toggle}
                size="medium"
                sx={{ color: '#fff' }}
            >
                <TranslateIcon sx={{ width: '24px', height: '24px' }} />
            </IconButton>
        </Tooltip>
    );
}

export default EditTranslationsIconButton;
